import { useCallback, useRef } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { SubscriptionData } from "../api/useWebSockets";

const INVALIDATE_DEBOUNCE_MS = 500;
const GAP_WINDOW_MS = 2 * 60 * 60 * 1000;

// gap techs only concern blocks around now, so a session update matters only when its
// start_date falls within a window of now (avoids refetching for far-off sessions)
export const useGapTechsInvalidate = () => {
	const queryClient = useQueryClient();
	const debounceTimeout = useRef<ReturnType<typeof setTimeout>>();

	const handleGapTechsEvent = useCallback(
		(subscriptionData: SubscriptionData) => {
			if (subscriptionData.event !== "update" || !Array.isArray(subscriptionData.data)) return;

			const now = Date.now();
			const withinGapWindow = subscriptionData.data.some((session: any) => {
				if (!session?.start_date) return false;
				const startMs = new Date(session.start_date).getTime();
				return Math.abs(startMs - now) <= GAP_WINDOW_MS;
			});
			if (!withinGapWindow) return;

			clearTimeout(debounceTimeout.current);
			debounceTimeout.current = setTimeout(() => {
				queryClient.invalidateQueries({ predicate: (query) => query.queryKey[0] === "gap-techs" });
			}, INVALIDATE_DEBOUNCE_MS);
		},
		[queryClient]
	);

	return { handleGapTechsEvent };
};
